import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';

import { TdLoadingService } from '@covalent/core';
import { LoginService } from '../../services';

import { Profesional } from '../../models';

@Component({
  selector: 'qs-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {

  profesional: Profesional = new Profesional();

  constructor(private _router: Router,
    private _loadingService: TdLoadingService,
    private _loginService: LoginService) { }

  @HostListener('document:keypress', ['$event'])
    handleKeyboardEvent (event: KeyboardEvent): void {
      if (event.key === 'Enter') {
        this.login();
      }
  }

  login(): void {
    this._loadingService.register();
    this._loginService.login(this.profesional.dni.trim(), this.profesional.clave.trim()).subscribe(() => {
      if (this._loginService.isLoggedIn) {
        let redirect: any = this._loginService.redirectUrl ? this._loginService.redirectUrl : '/main';
        this._loadingService.resolve();
        this._router.navigate([redirect]);
      } else {
        this._loadingService.resolve();
      }
    }, (error: any): any => {
       this._loadingService.resolve();
    } );
  }

  loginClave(): void {
    this._loadingService.register();
    this._loginService.login('12121212M', 'prueba2').subscribe(() => {
      if (this._loginService.isLoggedIn) {
        let redirect: any = this._loginService.redirectUrl ? this._loginService.redirectUrl : '/main';
        this._loadingService.resolve();
        this._router.navigate([redirect]);
      } else {
        this._loadingService.resolve();
      }
    }, (error: any): any => {
       this._loadingService.resolve();
    } );
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts